<!--申请售后，退货退款组件 -->
<template>
  <div>
    <van-button
      @click="afterDetail"
      v-show="isAfter == 'n' "
      round
      plain
      normal
      hairline
      size="small"
    >{{afterText || '售后中'}}</van-button>
    <!-- <van-button
      @click="afterDetail"
      v-show="isAfter == 's' && afterText"
      round
      plain
      normal
      hairline
      size="small"
    >{{afterText}}</van-button> -->
    <van-button
      @click="saleAfter(subId, goodId)"
      v-show="isAfter =='y' && (orderStatus=='WAIT_RECEIVING' || orderStatus=='COMPLETED')" 
      round
      plain
      normal
      hairline
      size="small"
    >申请售后</van-button>
    <van-button
      class="gray"
      @click="afterTip"
      v-show="orderStatus == 'WAIT_SEND' && isAfter =='y' && isAfterByBees == 'y' && (!afterText || afterText == '')"
      round
      plain
      normal
      hairline
      size="small"
    >申请退款</van-button>
  </div>
</template> 
<script>
import { Toast } from "vant";
export default {
  props: {
    isAfter: {
      type: String,
      default: "",
      required: true
    },
    subId: {
      type: Number,
      default: 0,
      required: true
    },
    goodId: {
      type: Number,
      default: 0,
      required: false
    },
    afterId: {
      type: Number,
      default: 0,
      required: false
    },
    afterText: {
      type: String,
      default: "",
      required: false
    },
    orderStatus:{
      type:String,
      default:''
    },
    isAfterByBees:{
      type:String,
      default: 'n'
    },
    role:{
      type:String,
      default:''
    },
    goodsRefundType:{
      type:String,
      default:''
    },
    goodsExchangeType:{
      type:String,
      default:''
    },
    isAllowedVirtualAfter:{
      type:Boolean,
      default:false
    }

    // isAfterByBees:{
    //   type:String,
    //   default:''
    // },
  },
  data() {
    return {
      show: true
    };
  },
  methods: {
    //售后详情
    afterDetail(id) {
      this.$router.push({
        name: "userAfterOrderDetail",
        query: { afterId: this.afterId }
      });
    },
    //退货退款
    saleAfter(subId, goodid) {
       console.log('this.goodsRefundType',this.goodsRefundType)
      //  return false
      if(this.goodsRefundType == 'NONREFUNDABLE' && this.goodsExchangeType == 'NONREFUNDABLE'){
        Toast("请联系店铺导购申请售后");
      }else{
        this.$router.push({
          name: "userRefundCommodity",
          query: { subid: subId, goodid: goodid ,orderStatus:this.orderStatus}
        });
      }

    },
    afterTip() {
      console.log(11);
      Toast("已发生过部分商品项退款，请联系蜜蜂进行其他商品项退款");
    }
  },
  created() {
    console.log(this.isAfter);
    this.show = this.isAfter == "n" ? true : false;
  },
  components: {}
};
</script>
<style lang="less" scoped>
.gray {
  // background-color: #d7d7d7!important
  border-color: #999999;
  color: #999999;
  background-color: #fff;
}
</style>